import React from 'react';
import { Clock, Users, XCircle, CheckCircle } from 'lucide-react';

const PendingMessageCard = ({ job, onCancel }) => {
  const getStatusColor = (status) => {
    switch(status) {
      case 'pending': return { bg: '#FEF3C7', text: '#D97706' };
      case 'sent': return { bg: '#D1FAE5', text: '#059669' };
      case 'failed': return { bg: '#FEE2E2', text: '#DC2626' };
      case 'cancelled': return { bg: '#F3F4F6', text: '#6B7280' };
      default: return { bg: '#F3F4F6', text: '#6B7280' };
    }
  };

  const statusStyle = getStatusColor(job.status);
  
  const formatDate = (dateStr) => {
    if (!dateStr) return 'Immediate';
    const d = new Date(dateStr);
    return d.toLocaleString('en-US', { 
      month: 'short', day: 'numeric', 
      hour: 'numeric', minute: '2-digit', hour12: true 
    });
  };

  return (
    <div style={{
      background: 'var(--color-background-primary)',
      border: '1px solid var(--color-border-primary)',
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h4 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '4px' }}>
            Template: {job.templateName || 'Unknown Template'}
          </h4>
          <span style={{ 
            fontSize: '12px', 
            background: statusStyle.bg, 
            color: statusStyle.text,
            padding: '2px 8px',
            borderRadius: '12px',
            fontWeight: '500',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            {job.status === 'sent' && <CheckCircle size={12} />}
            {job.status === 'pending' && <Clock size={12} />}
            {job.status.charAt(0).toUpperCase() + job.status.slice(1)}
          </span>
        </div>
        
        {job.status === 'pending' && (
          <button 
            onClick={() => onCancel(job._id)}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--color-text-tertiary)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '13px',
              padding: '4px 8px',
              borderRadius: '4px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#FEE2E2';
              e.currentTarget.style.color = '#DC2626';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = 'var(--color-text-tertiary)';
            }}
          >
            <XCircle size={16} /> Cancel
          </button>
        )}
      </div>

      <div style={{ display: 'flex', gap: '24px', borderTop: '1px solid var(--color-border-secondary)', paddingTop: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--color-text-secondary)', fontSize: '14px' }}>
          <Users size={16} color="var(--color-brand-primary)" />
          <span><b>{job.leadCount}</b> leads</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--color-text-secondary)', fontSize: '14px' }}>
          <Clock size={16} color="var(--color-brand-primary)" />
          <span>{formatDate(job.scheduledAt)}</span>
        </div>
      </div>
      
      <div style={{ fontSize: '12px', color: 'var(--color-text-tertiary)', marginTop: '-8px' }}>
        Created by {job.createdByName} on {formatDate(job.createdAt)}
      </div>
    </div>
  );
};

export default PendingMessageCard;
